import {
  FOOD_PREORDER_EVENT_REPORT_REQUEST,
  FOOD_PREORDER_EVENT_REPORT_SUCCESS,
  FOOD_PREORDER_EVENT_REPORT_FAIL,
} from "./actionType";

const initialState = {
  foodPreOrderEventReportSummary: null,
  foodPreOrderEventReportEvents: [],
  foodPreOrderEventReportLoading: false,
  foodPreOrderEventReportError: null,
};

const FoodPreOrderEventReport = (state = initialState, action) => {
  switch (action.type) {
    case FOOD_PREORDER_EVENT_REPORT_REQUEST:
      return {
        ...state,
        foodPreOrderEventReportLoading: true,
        foodPreOrderEventReportError: null,
      };

    case FOOD_PREORDER_EVENT_REPORT_SUCCESS:
      return {
        ...state,
        foodPreOrderEventReportLoading: false,
        foodPreOrderEventReportSummary: action.payload?.summary || null,
        foodPreOrderEventReportEvents: action.payload?.event_list || [],
      };

    case FOOD_PREORDER_EVENT_REPORT_FAIL:
      return {
        ...state,
        foodPreOrderEventReportLoading: false,
        foodPreOrderEventReportError: action.payload,
      };

    default:
      return state;
  }
};

export default FoodPreOrderEventReport;
